import * as ActionTypes from '../constants/ActionTypes'
import { getRequest, postRequest } from './http'

export function loading() {
  return {
    type: ActionTypes.LOADING_CHANGE
  }
}

export function setData(items, name) {
  return {
    type: ActionTypes.DATA,
    name: name,
    items: items
  }
}

export function setDataConcat(items, name) {
  return {
    type: ActionTypes.DATA_CONCAT,
    name: name,
    items: items
  }
}

export function data_with_pagination(items, name) {
  return {
    type: ActionTypes.DATA_WITH_PAGINATION,
    name: name,
    items: items
  }
}

export function errorForm(errors){
  return{
    type: ActionTypes.SET_ERROR_FORMS,
    errors: errors
  }
}

export function changeFields(fields){
  return {
    type: ActionTypes.SET_FIELDS,
    fields: fields
  }
}

const getmessages = (data, typeOption) => {
  data.typeOption = typeOption;
  return (dispatch) => {
    dispatch(loading());
    getRequest(data, "messages").then(
    (response) => {
      dispatch(data_with_pagination(response.data.inbox, 'inbox'));
      dispatch(data_with_pagination(response.data.sent, 'sent'));
      dispatch(loading());
    },
    (err) => {
      dispatch(loading());
      if (err.response.status === 401) {
        dispatch(setData(true, 'error401'));
      }else{
        dispatch(setData(true, 'error'));
      }
    }
    );
  }
};

const getmessage = (data, typeOption) => {
  data.typeOption = typeOption;
  return (dispatch) => {
    dispatch(loading());
    getRequest(data, "messages").then(
    (response) => {
      if (typeOption !== "auxiliares") {
        response.data.mensaje[0].destino.split(",").forEach((element, key) => {
          dispatch(setDataConcat({value: key, label: element},'options2'));
          dispatch(setDataConcat({value: key, label: element},'selectedOption2'));
        });
      }
      dispatch(setData(response.data.auxiliares, 'options'));
      dispatch(loading());
    },
    (err) => {
      dispatch(loading());
      if (err.response.status === 401) {
        dispatch(setData(true, 'error401'));
      }else{
        dispatch(setData(true, 'error'));
      }
    }
    );
  }
};

const getsent = (data, typeOption) => {
  data.typeOption = typeOption;
  return (dispatch) => {
    dispatch(loading());
    getRequest(data, "messages").then(
    (response) => {
      dispatch(data_with_pagination(response.data.sent, 'sent'));
      dispatch(loading());
    },
    (err) => {
      dispatch(loading());
      if (err.response.status === 401) {
        dispatch(setData(true, 'error401'));
      }else{
        dispatch(setData(true, 'error'));
      }
    }
    );
  }
};

const sendMessages = (data, typeOption) => {
  data.typeOption = typeOption;
  return (dispatch) => {
    dispatch(loading());
    dispatch(errorForm({'errors':{}}));
    postRequest(data, "messages").then(
      (response) => {
        dispatch(changeFields(data));
        dispatch(setData('Mensaje enviado correctamente', 'toastMessage'));
        dispatch(setData(true, 'simpleToast'));
        setTimeout(function(){
          dispatch(setData(false, 'simpleToast'));
        }, 3000);
        dispatch(loading());
      },
      (err) => {
        dispatch(errorForm(err.response.data));
        dispatch(loading());
      }
    );
  }
};

export default {
  getmessages,
  setData,
  getsent,
  changeFields,
  sendMessages,
  errorForm,
  getmessage,
  setDataConcat
}
